/**
 * The global cache for tag names
 *
 * @type {WeakMap<typeof HTMLElement, string>}
 */
var globalTagsCache = new WeakMap();

/**
 * Adds a tag to the global tags cache
 *
 * @param {string} tag
 * @param {typeof HTMLElement} klass
 */
var addToGlobalTagsCache = function addToGlobalTagsCache(tag, klass) {
  return globalTagsCache.set(klass, tag);
};

/**
 * Gets a tag from the global tags cache
 *
 * @exports
 * @param {typeof HTMLElement} klass
 * @returns {undefined|string}
 */
var getFromGlobalTagsCache = function getFromGlobalTagsCache(klass) {
  return globalTagsCache.get(klass);
};

export { addToGlobalTagsCache, getFromGlobalTagsCache };
